import React from "react";

/**
 * Diamond currency icon, drawn as six facets like the in-game one.
 *
 * Inline SVG rather than a bitmap on purpose: `fill="currentColor"` makes it take the colour of the
 * surrounding text for free, so it always matches the font wherever it is used.
 */
const DiamondIcon = () => (
    <svg className="currency-icon" viewBox="0 0 24 24" focusable="false" role="img" aria-label="diamonds">
      <g fill="currentColor">
        {/* Crown: three facets above the girdle */}
        <polygon points="1.5,9.7 5.0,4.3 7.6,9.7" />
        <polygon points="5.6,4.3 18.4,4.3 15.9,9.7 8.1,9.7" />
        <polygon points="19.0,4.3 22.5,9.7 16.4,9.7" />
        {/* Pavilion: three facets converging on the point */}
        <polygon points="1.5,10.3 7.5,10.3 11.3,20.4" />
        <polygon points="8.1,10.3 15.9,10.3 12.0,21.2" />
        <polygon points="16.5,10.3 22.5,10.3 12.7,20.4" />
      </g>
    </svg>
);

export default DiamondIcon;
